var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.83464 14.666V5.15768L5.8013 8.19102L4.16797 6.49935L10.0013 0.666016L15.8346 6.49935L14.2013 8.19102L11.168 5.15768V14.666H8.83464ZM3.0013 19.3327C2.35964 19.3327 1.81033 19.1042 1.35339 18.6473C0.896441 18.1903 0.667969 17.641 0.667969 16.9994V13.4993H3.0013V16.9994H17.0013V13.4993H19.3346V16.9994C19.3346 17.641 19.1062 18.1903 18.6492 18.6473C18.1923 19.1042 17.643 19.3327 17.0013 19.3327H3.0013Z",
    fill: "#181716"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.50d54653cf9a47decf6bca554241258b.svg";
export { ForwardRef as ReactComponent };